const getApiAuthToken = (state: any): string | null => {
  if (!state || !state.auth) {
    return null;
  }
  if (state.auth.OAuthToken) {
    return state.auth.OAuthToken;
  }
  return state.auth.sessionToken;
};

export default getApiAuthToken;
